import { Component, EventEmitter, Output, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SeahorseToastTemplate } from '../../../shared/templates/seahorse-toast.template';
import { IndividualConfig } from 'ngx-toastr';

@Component({
  selector: 'ca-export-ready-toast',
  template: `
    <div class="wrapper">
      <span class="title">{{
        'contentDistribution.exportTemplate.exportReadyNotification.title'
          | translate
      }}</span>
      <div class="body">
        {{
          'contentDistribution.exportTemplate.exportReadyNotification.body'
            | translate: { file: filename }
        }}
      </div>
      <button class="action btn btn-primary" (click)="downloadExport()">
        {{ 'shared.terms.download' | translate }}
      </button>
    </div>
  `,
  styles: [
    `
      .wrapper {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
      }
      .action {
        width: 100px;
      }
      .title {
        font-size: 1.1rem;
        font-weight: 600;
      }
      .body {
        font-size: 1rem;
      }
    `,
  ],
  imports: [TranslateModule],
})
export class ExportReadyToastTemplate extends SeahorseToastTemplate<{
  filename: string;
}> {
  @Output() download = new EventEmitter<void>();

  get filename() {
    return this.options?.payload?.filename;
  }

  toastClasses = this.defaultToastClasses + ' toast-success';

  downloadExport() {
    this.download.emit();
  }
}
